import type { OnInit } from '@angular/core';
import { Component, ElementRef, forwardRef, Renderer2 } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseSelectFormFieldComponent } from '@shared/form-fields/select/base-select-form-field.component';
import type { DurationRoundingStyle } from '../../../contracts/common/duration-rounding/duration-rounding';

@Component({
    selector: 'app-duration-rounding-style-select',
    styleUrls: ['./duration-rounding-style-select.component.scss'],
    templateUrl: '../../../../form-fields/select/select-form-field.component.html',
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DurationRoundingStyleSelectComponent), multi: true }],
})
export class DurationRoundingStyleSelectComponent extends BaseSelectFormFieldComponent<DurationRoundingStyle> implements OnInit {

    constructor(element: ElementRef, renderer: Renderer2) {
        super(element, renderer);

        this.options = [
            { value: null, label: 'None' },
            { value: 'round', label: 'Round to nearest' },
            { value: 'ceil', label: 'Round up to nearest' },
            { value: 'floor', label: 'Round down to nearest' },
        ];
    }

}
